// extracted by mini-css-extract-plugin
module.exports = {"exam_rule_config_wrapper":"ExamRuleConfig_exam_rule_config_wrapper__3t1iH"};